import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PermissionView } from "./PermissionView";
import { PermissionViewStore } from "../../store/PermissionViewStore";
import { useStore } from "../../../../hooks";

export const PermissionViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/permission/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PermissionViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PermissionView permissionViewStore={store} />
      </PageLayout>
    </div>
  );
});
